import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TopContent = styled.section`
  display: grid;
  grid-row-gap: 4px;

  margin-bottom: 64px;
`;
